
import React from 'react';
import { ViewState } from '../types';
import { BrandLogo } from './BrandIdentity';

interface FooterProps {
  onNavigate?: (view: ViewState) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="py-16 md:py-24 border-t border-black/5 grainy bg-white">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="flex flex-col items-center md:items-start gap-3">
          <BrandLogo size="md" className="items-center md:items-start" />
          <div className="flex flex-col md:flex-row items-center gap-4 mt-2">
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.4em]">© {new Date().getFullYear()} Hoppy Collective</p>
            <div className="hidden md:block w-1 h-1 rounded-full bg-gray-200" />
            <div className="flex items-center gap-4">
              <button 
                onClick={() => onNavigate?.('privacy-policy')}
                className="text-[9px] font-black text-gray-400 hover:text-amber-600 transition-colors uppercase tracking-[0.2em]"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => onNavigate?.('terms-of-service')}
                className="text-[9px] font-black text-gray-400 hover:text-amber-600 transition-colors uppercase tracking-[0.2em]"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="space-y-1 text-center md:text-right">
            <span className="block text-[10px] font-black uppercase tracking-[0.4em] text-amber-600 mb-2">Support & Partnerships</span>
            <a 
              href="mailto:hello@hoppy-hours.com" 
              className="text-xl md:text-3xl font-black serif text-black hover:text-amber-600 transition-colors underline decoration-amber-200 decoration-4 underline-offset-4"
            >
              hello@hoppy-hours.com
            </a>
          </div>
          <p className="text-[9px] font-bold text-gray-300 uppercase tracking-widest">More cities and features launching soon.</p>
        </div>
      </div>
    </footer>
  );
};
